export const TEAM_PATHS = ['/team/join/:teamCode?'] as const
